import styles from '../../style.module.scss';
import useStore from "../../store/store";
import formatPrice from "../../utils/format-price";

const SummaryBonus = () => {
    const user = useStore((state) => state.user)
    const bonusPay = useStore((state) => state.bonusPay)
    const setBonusPay = useStore((state) => state.setBonusPay)

    if (!!user && !!user?.bonus) {
        return (
            <div className={styles.bonus}>
                <div className={styles.label}>
                    Баланс бонусов
                    <div className={styles.sum}>{formatPrice(user.bonus)}</div>
                </div>
                <div className={styles.apply} onClick={()=>setBonusPay(!bonusPay)}>
                    Списать
                    <div className={`${styles.check} ${!!bonusPay && styles.active}`}/>
                </div>
            </div>
        );
    }
    return null;
};

export default SummaryBonus;